(function(){
  function debounce(fn, wait){ let t; return function(){ clearTimeout(t); t = setTimeout(fn, wait); }; }
  function serializeAndNavigate(form){
    if (!form) return;
    var urlBase = window.location.pathname;
    var params = new URLSearchParams();
    var current = new URL(window.location.href);
    var q = current.searchParams.get('q');
    if (q) params.set('q', q);
    var sortSelect = form.querySelector('select[name="sort_by"]');
    if (sortSelect && sortSelect.value) params.set('sort_by', sortSelect.value);

    var inputs = form.querySelectorAll('input[type="checkbox"], input[type="radio"], input[type="number"], select');
    inputs.forEach(function(inp){
      if ((inp.type === 'checkbox' || inp.type === 'radio') && inp.checked){
        params.append(inp.name, inp.value);
      } else if (inp.type === 'number' && inp.value){
        params.set(inp.name, inp.value);
      } else if (inp.tagName.toLowerCase() === 'select' && inp.name && inp.value && inp.name !== 'sort_by'){
        params.append(inp.name, inp.value);
      }
    });

    var qString = params.toString();
    var newUrl = urlBase + (qString ? '?' + qString : '');
    window.location.href = newUrl;
  }

  document.addEventListener('change', debounce(function(e){
    var form = e.target.closest('.facets__form');
    if (!form) return;
    if (e.target.matches('input[type="checkbox"], input[type="radio"], input[type="number"], select')) {
      serializeAndNavigate(form);
    }
  }, 250));
})();
